import React from 'react';
import ProductResources from './ProductResources';

// Phase 21's kill-switch router was retired 2026-05-15 — the new
// product_resources-backed view is the only path now. ProductsLegacy.jsx
// and the transly.products.legacy localStorage flag are gone.
export default function Products() {
  return <ProductResources />;
}
